import type { TQuestionAnswer } from '$/types/components/questions';
import type { IInputQuestion } from './_question';
import type { ISelectAnswer } from '../SelectAnswer';

import { Controller } from 'react-hook-form';

import SelectAnswer from '../SelectAnswer';

import Subtitle from './elements/Subtitle';
import Title from './elements/Title';

import getControlError from '$/hooks/getControlError';
import useElb from '$/hooks/useElb';
import ErrorMessages from '$/types/enums/ErrorMessages';
import { TRACKING_ENTITY } from '$/utils/tracking/consts';

interface ISelectAnswerInputQuestion
  extends IInputQuestion,
    Omit<ISelectAnswer, 'fieldProps'> {
  onValueSelected?: (data?: TQuestionAnswer[] | any) => void;
  selectFieldElbEntity?: string;
  selectFieldElbAction?: string;
}

const SelectAnswerInputQuestion = ({
  control,
  title,
  subTitle,
  name,
  onValueSelected,
  selectFieldElbEntity = TRACKING_ENTITY.STUDY_FINANCING,
  selectFieldElbAction,
  ...props
}: ISelectAnswerInputQuestion) => (
  <Controller
    control={control}
    name={name}
    defaultValue={[]}
    render={({ field, fieldState }) => {
      const { sendTrackingEvent } = useElb();
      const error = getControlError(control, name, props.errorMessage);
      const onChange = (data: TQuestionAnswer[]) => {
        if (selectFieldElbEntity && selectFieldElbAction) {
          sendTrackingEvent(selectFieldElbEntity, selectFieldElbAction);
        }
        field.onChange(data);
        if (data?.length > 0 && onValueSelected) {
          onValueSelected(data);
        }
      };
      return (
        <>
          {title && <Title>{title}</Title>}
          {subTitle && <Subtitle>{subTitle}</Subtitle>}
          <SelectAnswer
            fieldProps={{
              name: field.name,
              value: field.value ?? [],
              onChange,
            }}
            {...props}
            error={fieldState.invalid}
            errorMessage={
              typeof error.message === 'string' &&
              (
                [
                  ErrorMessages.REQUIRED_FIELD,
                  ErrorMessages.NO_VALUE_ENTERED,
                ] as string[]
              ).includes(error.message)
                ? 'Bitte auswählen'
                : error.message
            }
          />
        </>
      );
    }}
  />
);

SelectAnswerInputQuestion.defaultProps = {
  maxElements: 1,
};

export default SelectAnswerInputQuestion;
